import * as React from 'react';

export default (alternateTitleLabel) => [
  {
    id: 'checkbox',
    numeric: false,
    disablePadding: false,
    label: null,
    width: '5%',
    isCheckbox: true,
  },
  {
    id: 'title',
    numeric: false,
    disablePadding: false,
    label: alternateTitleLabel || 'Title',
    width: '25%',
    sortable: true,
  },
  {
    id: 'documentTypeDisplayName',
    numeric: false,
    disablePadding: false,
    label: 'Document Type',
    width: '15%',
    sortable: true,
  },
  {
    id: 'vintageFundNames',
    numeric: false,
    disablePadding: false,
    label: 'Fund',
    width: '22%',
    sortable: true,
  },
  {
    id: 'publicationDate',
    numeric: false,
    disablePadding: false,
    label: 'Date Issued',
    width: '18%',
    sortable: true,
  },
  {
    id: 'view',
    numeric: false,
    disablePadding: false,
    label: null,
    width: '15%',
    sortable: false,
  },
];
